var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464 288H48C21.5 288 0 309.5 0 336V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V336C512 309.5 490.5 288 464 288ZM320 416C302.375 416 288 401.625 288 384S302.375 352 320 352S352 366.375 352 384S337.625 416 320 416ZM416 416C398.375 416 384 401.625 384 384S398.375 352 416 352S448 366.375 448 384S433.625 416 416 416ZM464 32H48C21.5 32 0 53.5 0 80V272.406C13.414 262.254 29.922 256 48 256H464C482.078 256 498.586 262.254 512 272.406V80C512 53.5 490.5 32 464 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDrive);
export default __webpack_public_path__ + "static/media/hard-drive.b5e39e349b8a6f2d50e627b456e978ad.svg";
export { ForwardRef as ReactComponent };